import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/img/kabe-sub-banner-mobile.webp")